import React, { createContext } from 'react';
import { compose, omit, append, forEachObjIndexed } from 'ramda';
import ReactTouchEvents from 'react-touch-events';

import styleFile from './slide.js';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import Button from '@synergycms_core/components/generic/Button';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

export const SlideContext = createContext({});


export const SlideDots = compose(
    PropertyManager(['direction', 'rightIcon', 'icon','showButtons', 'slideType','className']),
    withThemeJSS({ styleFile }, null, 'slideDotts')
  )(
    class SlideDots extends React.Component {
        static contextType = SlideContext;
        static displayName = "Slide";

        render() {
            const { goToDot, showButtons, slideType } = this.context;
            const { className } = this.props.config;
            let enabled = true;
            if (slideType) {
                enabled = this.props.direction === 'next' ? this.context.imageList.length - 2 !== this.context.position : 0 !== this.context.position;
            }
            return (
              <div className={className}>
                {showButtons && enabled && this.context.imageList.map((image, key) =>
                    <Button
                      {...this.props}
                      onClick={() => goToDot(key)}
                      key={key}
                      text={image.text}
                      innerStyle={[
                        className,
                        image.key,
                        this.context.index === key ? "dotSelected" : "dotNotSelected"
                      ]}
                    />
                )}
              </div>
            );
        }
    }
  );



export const ButtonSlide = compose(
    PropertyManager(['direction', 'icon']),
    withThemeJSS({ styleFile }, null, 'slideButton')
)(
    class ButtonSlide extends React.Component {
        static contextType = SlideContext;
        static displayName = "Slide";
        render() {
            const { theme } = this.props;
            const { classes } = theme.styles;
            const { next, prev, showButtons, slideType } = this.context;
            //const { config, theme } = this.props;
            let enabled = true;
            if (slideType) {
                enabled = this.props.config.direction === 'next' ? this.context.imageList.length - 2 !== this.context.position : 0 !== this.context.position;
            }
            return (
                showButtons && enabled && (
                    <Button
                        onClick={this.props.config.direction === 'next' ? next : prev}
                        config={{
                            ...this.props.config,
                            innerStyle: [this.props.theme.computedInnerStyle, this.props.config.direction === 'next' ? classes.nextButton : classes.prevButton]
                        }}
                    />
                )
            );
        }
    }
);

export const WrapperSlide = compose(
    PropertyManager(['wrapperContent', 'wrapper', 'transitionSpeed']),
    withThemeJSS({ styleFile }, null, null, false)
)(
    class WrapperSlide extends React.Component {
        static displayName = 'Slide';
        constructor(props, context) {
            super(props);
        }

        static contextType = SlideContext;

        render() {
            //const { showImage, selected, selectedKey } = this.props.config;
            //const { computedInnerStyle } = this.props.theme;
            const { viewImageList, transition } = this.context;
            const { theme, config } = this.props;
            const {transitionSpeed} = this.props.config;
            const { classes } = theme.styles;
            let transitionClasses = {};
            if (transition === 'next') {
                transitionClasses = {
                    enter: classes.backgroundEnter,
                    enterActive: classes.backgroundEnterActive,
                    exit: classes.backgroundLeave,
                    exitActive: classes.backgroundLeaveActive
                };
            } else if (transition === 'prev') {
                transitionClasses = {
                    enter: classes.backgroundEnterPrev,
                    enterActive: classes.backgroundEnterActivePrev,
                    exit: classes.backgroundLeavePrev,
                    exitActive: classes.backgroundLeaveActivePrev
                };
            }

            return (
                <div className={theme.styleGetter([classes.defaultStyle, theme.computedInnerStyle])}>
                    <ul className={theme.styleGetter([classes.wrapperContent, config.wrapperContent])}>
                        <TransitionGroup>
                            {viewImageList.length &&
                                viewImageList.map(image => {
                                    return (
                                        <CSSTransition enter={true} exit={true} key={image.key} timeout={transitionSpeed || 1000} classNames={transitionClasses}>
                                            {image.content}
                                        </CSSTransition>
                                    );
                                })}
                        </TransitionGroup>
                    </ul>
                </div>
            );
        }
    }
);

export const WrapperMultiSlide = compose(
    PropertyManager(['wrapperContent', 'wrapper']),
    withThemeJSS({ styleFile }, null, null, false)
)(
    class WrapperMultiSlide extends React.Component {
        static displayName = 'Slide';
        constructor(props, context) {
            super(props);
            this.state = {
                elems: [],
                width: 0
            };
            this.elems = {};
        }

        static contextType = SlideContext;

        setRef = (image) => (elem) => {
            if (!this.elems[image.key]) {
                this.elems[image.key] = elem;
                this.forceUpdate();
            }
        }

        setBaseRef = (elem) => {
            this.baseRef = elem;
        }

        isMobile = () => {
            return this.props.theme.deviceType !== 'DESK';
        };
        componentDidUpdate = () => {
            if (this.baseRef) {
                this.context.setEnableArrows(this.baseRef.offsetWidth < this.initialWidth);
            }
        }

        render() {
            //const { showImage, selected, selectedKey } = this.props.config;
            //const { computedInnerStyle } = this.props.theme;
            const { imageList, position, showModalView } = this.context;
            const { theme, config } = this.props;
            const { classes } = theme.styles;
            let initialWidth = 0;
            let currentPosition = 0;
            let marginLeft = 0;
            let enableRightShadow = this.isMobile() && (this.props.config.direction === 'next' ? this.context.imageList.length - 2 !== this.context.position : 0 !== this.context.position);

            let enableLeftShadow = this.isMobile() && (this.props.config.direction === 'prev' ? 0 === this.context.position : this.context.imageList.length - 2 > this.context.position);

            forEachObjIndexed((elem, key) => {
                if (this.props.theme.deviceType === 'DESK') {
                    if (position > currentPosition) {
                        marginLeft -= elem.offsetWidth;
                    }
                    currentPosition++;
                    this.initialWidth = initialWidth = initialWidth + elem.offsetWidth;
                }
            }, this.elems);

            return (
                <div className={[theme.styleGetter([classes.defaultStyle, this.props.theme.computedInnerStyle]),
                showModalView ? classes.shadowColor : classes.defaultShadowColor,
                enableRightShadow ? classes.leftShadow : classes.noShadowLeft,
                enableLeftShadow ? classes.rightShadow : classes.noShadowRight].join(' ')}>
                    <div ref={this.setBaseRef} className={theme.styleGetter([classes.wrapperMultiContent, config.wrapperMultiContent])}>
                        <div style={{ width: initialWidth, marginLeft: marginLeft }} className={theme.styleGetter(classes.nestedMultiContent)}>
                            {imageList.length && imageList.map(image => {
                                return (<div key={image.key} ref={this.setRef(image)}>{image.content}</div>);
                            })}
                        </div>
                    </div>
                </div >
            );
        }
    }
);

export const SlideItem = compose(
    PropertyManager(['contentKey', 'children', 'text']),
    withThemeJSS({ styleFile }, null, 'itemBox')
)(
    class SlideItem extends React.Component {
        static contextType = SlideContext;
        static displayName = "Slide";

        constructor(props) {
            super(props);
            this.state = {
                enableCursorSwipe: false,
                max: 0,
                min: 0
            };

        }
        componentDidMount = () => {
            this.updateDataImage();
        };

        componentWillUnmount = () => {
            this.context.unSubscribeImage(this.props.config.contentKey);
        };

        onMouseDown = e => {
            this.setState({ enableCursorSwipe: true });
        };

        onMouseMove = e => {
            if (this.state.enableCursorSwipe) {
                const max = e.movementX > this.state.max ? e.movementX : this.state.max;
                const min = e.movementX < this.state.min ? e.movementX : this.state.min;
                if (max !== this.state.max || min !== this.state.min) {
                    this.setState({
                        max: max,
                        min: min
                    });
                }
            }
        };

        onMouseUp = e => {
            if (this.state.max > 30) {
                this.context.prev();
            } else if (this.state.min < -30) {
                this.context.next();
            }
            this.setState({
                enableCursorSwipe: false,
                max: 0,
                min: 0
            });
        };

        updateDataImage = () => {

            this.context.subscribeImage({
                key: this.props.config.contentKey,
                text:this.props.config.text,
                content: (
                    <ReactTouchEvents
                        onSwipe={direction => {
                            if (direction === 'right') {
                                this.context.prev();
                            } else if (direction === 'left') {
                                this.context.next();
                            }
                        }}>
                        <div
                            onMouseDown={this.onMouseDown}
                            onMouseMove={this.onMouseMove}
                            onMouseUp={this.onMouseUp}
                            className={this.props.theme.computedInnerStyle}>
                            {this.props.children}
                        </div>
                    </ReactTouchEvents>
                )
            });
        };

        render = () => {
            return null;
        };
    }
);
//TODO s'hauria de comprovar l'eficiencia dels imageContent, automaticament s'esimageleix una key, tot i q realment només es mostra 1
const Slide = class Slide extends React.Component {
    static displayName = "Slide";

    constructor(props) {
        super(props);
        let selected;
        this.state = {
            selectedKey: selected || 0,
            ready: false,
            imageList: [],
            viewImageList: [],
            index: 0,
            inProgress: false,
            transition: '',
            position: 0,
            enableArrows: false
        };
    }

    componentDidMount() {
        this.slideEvent = e => {
            if (e.keyCode === 39) {
                this.next(e);
            } else if (e.keyCode === 37) {
                this.prev(e);
            }
        };
        window.addEventListener('keyup', this.slideEvent);
    }

    componentWillUnmount() {
        window.removeEventListener('keyup', this.slideEvent);
    }

    subscribeImage = image => {
        this.setState(state => {
            const viewImageList = !state.viewImageList.length ? [image] : state.viewImageList;
            return {
                //selectedKey: !state.selectedKey ? image.key : state.selectedKey,
                imageList: append(image, state.imageList),
                viewImageList: viewImageList
            };
        });
    };

    next = e => {
        if (!this.state.inProgress) {
            this.setState(
                state => {
                    return {
                        transition: 'next',
                        inProgress: true
                    };
                },
                () => {
                    this.setState(
                        state => {
                            let newIdx;
                            if (state.imageList[++state.index]) {
                                newIdx = state.index++;
                            } else {
                                newIdx = 0;
                            }
                            return {
                                index: newIdx,
                                viewImageList: [state.imageList[newIdx]]
                            };
                        },
                        () => {
                            this.props.config.propagateSelectedKey && this.props.config.propagateSelectedKey(this.state.index);
                            setTimeout(() => this.setState({ inProgress: false }), 1000);
                        }
                    );
                }
            );
        }
    };

    prev = e => {
        if (!this.state.inProgress) {
            this.setState(
                state => {
                    return {
                        transition: 'prev',
                        inProgress: true
                    };
                },
                () => {
                    this.setState(
                        state => {
                            let newIdx;
                            if (state.imageList[--state.index]) {
                                newIdx = state.index--;
                            } else {
                                newIdx = state.imageList.length - 1;
                            }
                            return {
                                index: newIdx,
                                viewImageList: [state.imageList[newIdx]]
                            };
                        },
                        () => {
                            this.props.config.propagateSelectedKey && this.props.config.propagateSelectedKey(this.state.index);
                            setTimeout(() => this.setState({ inProgress: false }), 1000);
                        }
                    );
                }
            );
        }
    };

    nextMulti = e => {
        if (!this.state.inProgress) {
            this.setState(
                state => {
                    return {
                        transition: 'next',
                        position: state.position < state.imageList.length - 1 ? state.position + 1 : state.position
                    };
                }
            );
        }
    };

    prevMulti = e => {
        if (!this.state.inProgress) {
            this.setState(
                state => {
                    return {
                        transition: 'prev',
                        position: state.position > 0 ? state.position - 1 : 0
                    };
                },
            );
        }
    };

    unSubscribeImage = key => {
        this.setState(state => {
            return {
                imageList: omit([key], state.imageList)
            };
        });
    };

    setEnableArrows = (enabled) => {
        if (this.enableArrows !== enabled) {
            this.enableArrows = enabled;
            this.setState(
                state => {
                    return {
                        enableArrows: enabled
                    };
                });
        }
    };

    goToDot = (idx,e) => {

        this.setState(
            state => {
                let newIdx = idx;
                if (!state.imageList[newIdx]) {
                    newIdx = 0;
                }
                return {
                    index: newIdx,
                    viewImageList: [state.imageList[newIdx]]
                };
            }
        );
                
    };

    render() {
        const { children } = this.props;
        const css = this.props.config.css || {};
        const { slideType, showModalView, group, transitionSpeed } = this.props.config;
        return (
            <React.Fragment>
                <SlideContext.Provider
                    value={{
                        subscribeImage: this.subscribeImage,
                        unSubscribeImage: this.unSubscribeImage,
                        setEnableArrows: this.setEnableArrows,
                        enableArrows: this.state.enableArrows,
                        viewImageList: this.state.viewImageList,
                        imageList: this.state.imageList,
                        showButtons: slideType === "multi" ? this.state.enableArrows : this.state.imageList.length > 1,
                        next: slideType === "multi" ? this.nextMulti : this.next,
                        prev: slideType === "multi" ? this.prevMulti : this.prev,
                        transition: this.state.transition,
                        goToDot : this.goToDot,
                        position: this.state.position,
                        slideType: slideType,
                        showModalView:showModalView,
                        group:group,
                        index: this.state.index
                    }}>
                    {slideType === "multi" ?
                        <WrapperMultiSlide
                            innerStyle={css.wrapper || this.props.config.wrapper}
                            wrapperContent={css.wrapperContent || this.props.config.wrapperContent}
                            transitionSpeed={transitionSpeed}
                        /> :
                        <WrapperSlide
                            innerStyle={css.wrapper || this.props.config.wrapper}
                            wrapperContent={css.wrapperContent || this.props.config.wrapperContent}
                            transitionSpeed={transitionSpeed}
                        />}
                    {children}
                </SlideContext.Provider>
            </React.Fragment>
        );
    }
};

export default compose(
    PropertyManager([
        'children',
        'wrapper',
        'wrapperButtons',
        'wrapperContent',
        'css',
        'prevButtonStyle',
        'nextButtonStyle',
        'propagateSelectedKey',
        'slideType',
        'showModalView',
        'group',
        'transitionSpeed'
    ]),
    withThemeJSS({ styleFile, link: true }, null, null, false)
)(Slide);
